import { Component } from "react";
import ProductItem from "./ProductItem";
import "./ProductList.css";
class ProductList extends Component {
  render() {
    const productArray = [
      {
        id: 1,
        name: "Glory of the bull 1",
        image: "bull low.jpg",
        category: "Bull",
        price: "100000",
        offerPrice: "90000",
        width: "60",
        height: "36",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 2,
        name: "Glory of the bull 2",
        image: "cow low.jpg",
        category: "Bull",
        price: "110000",
        offerPrice: "90000",
        width: "60",
        height: "36",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 3,
        name: "The Enchanted Symphony of Strings",
        image: "musical band 2023 wm.jpg",
        category: "Music",
        price: "170000",
        offerPrice: "170000",
        width: "108",
        height: "36",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 4,
        name: "Melody of purple",
        image: "melody_of_purple_low.jpg",
        category: "Krishna",
        price: "170000",
        offerPrice: "170000",
        width: "48",
        height: "36",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 5,
        name: "Ganesha",
        image: "ganesha 2022.jpg",
        category: "Ganesha",
        price: "90000",
        offerPrice: "80000",
        width: "48",
        height: "60",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 6,
        name: "The butter flay whisper",
        image: "butterflay.jpg",
        category: "Music",
        price: "90000",
        offerPrice: "80000",
        width: "66",
        height: "36",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 7,
        name: "The butter flay whisper",
        image: "DSC_0585.jpg",
        category: "Music",
        price: "80000",
        offerPrice: "70000",
        width: "48",
        height: "54",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 8,
        name: "Parthasarathi 23",
        image: "525252.jpg",
        category: "Music",
        price: "90000",
        offerPrice: "80000",
        width: "48",
        height: "54",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 9,
        name: "The world on a string",
        image: "world-on-a-string-5.jpg",
        category: "Music",
        price: "90000",
        offerPrice: "70000",
        width: "78",
        height: "36",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 10,
        name: "Tunes of flut",
        image: "10.jpg",
        category: "Krishna",
        price: "90000",
        offerPrice: "80000",
        width: "48",
        height: "36",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 11,
        name: "Friendship",
        image: "friendship 2.jpg",
        category: "Music",
        price: "90000",
        offerPrice: "90000",
        width: "45",
        height: "45",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 12,
        name: "The mesmerizing tune",
        image: "the mesmerizing tunes low.jpg",
        category: "Music",
        price: "80000",
        offerPrice: "70000",
        width: "54",
        height: "48",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 13,
        name: "Face to face",
        image: "face-to-face.jpg",
        category: "Hourse",
        price: "56000",
        offerPrice: "56000",
        width: "48",
        height: "36",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 14,
        name: "Krishna Arjuna",
        image: "krishna-arjuna.jpg",
        category: "Krishna",
        price: "84000",
        offerPrice: "84000",
        width: "36",
        height: "47",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      // {
      //   id: 15,
      //   name: "The Blessing of Durga and Ganesha",
      //   image: "15.jpg",
      //   category: "Ganesha",
      //   price: "95200",
      //   offerPrice: "95200",
      //   width: "48",
      //   height: "60",
      //   inStock: "yes",
      //   description: "Acrylic on canvas",
      // },
      {
        id: 16,
        name: "God of Wisdom",
        image: "16.jpg",
        category: "Ganesha",
        price: "60000",
        offerPrice: "60000",
        width: "36",
        height: "66",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 17,
        name: "Energetic Ember",
        image: "17.jpg",
        category: "Bull",
        price: "60000",
        offerPrice: "60000",
        width: "60",
        height: "36",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 18,
        name: "Celestial Conversations",
        image: "18.jpg",
        category: "music",
        price: "100000",
        offerPrice: "90000",
        width: "60",
        height: "36",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 19,
        name: "Melodic Synchrony",
        image: "19.jpg",
        category: "music",
        price: "60000",
        offerPrice: "80000",
        width: "36",
        height: "36",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 20,
        name: "WHISPERS OF CONNECTION",
        image: "20.jpg",
        category: "music",
        price: "80000",
        offerPrice: "60000",
        width: "36",
        height: "36",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 21,
        name: "Harmonious Ensemble",
        image: "21.jpg",
        category: "music",
        price: "110000",
        offerPrice: "100000",
        width: "78",
        height: "36",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 22,
        name: "A Breath Of Music",
        image: "22.jpg",
        category: "music",
        price: "110000",
        offerPrice: "100000",
        width: "48",
        height: "54",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 23,
        name: "Harmonious Strings",
        image: "23.jpg",
        category: "music",
        price: "120000",
        offerPrice: "110000",
        width: "48",
        height: "60",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 24,
        name: "The Accompanist",
        image: "24.jpg",
        category: "music",
        price: "60000",
        offerPrice: "50000",
        width: "48",
        height: "30",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 25,
        name: "Devi",
        image: "25.jpg",
        category: "durga",
        price: "120000",
        offerPrice: "110000",
        width: "48",
        height: "60",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 26,
        name: "Couple",
        image: "26.jpg",
        category: "durga",
        price: "80000",
        offerPrice: "72000",
        width: "36",
        height: "48",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 27,
        name: "Melody of divine",
        image: "27.jpg",
        category: "ganesha",
        price: "200000",
        offerPrice: "190000",
        width: "96",
        height: "48",
        inStock: "yes",
        description: "Acrylic on canvas",
      },

      {
        id: 28,
        name: "The Mesmerizing Melody",
        image: "28.jpg",
        category: "music",
        price: "168000",
        offerPrice: "160000",
        width: "72",
        height: "48",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 29,
        name: "The Mesmerizing tunes",
        image: "29.jpg",
        category: "music",
        price: "140000",
        offerPrice: "130000",
        width: "48",
        height: "60",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 30,
        name: "A Musical Memoir ",
        image: "30.jpg",
        category: "music",
        price: "126000",
        offerPrice: "120000",
        width: "48",
        height: "54",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 31,
        name: "Agamoni ",
        image: "31.jpg",
        category: "Durga",
        price: "168000",
        offerPrice: "160000",
        width: "72",
        height: "48",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 32,
        name: "The Mesmerizing Tunes 18",
        image: "32.jpg",
        category: "krishna",
        price: "84000",
        offerPrice: "80000",
        width: "36",
        height: "48",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 33,
        name: "Musical band 12",
        image: "33.jpg",
        category: "Music",
        price: "210000",
        offerPrice: "0",
        width: "72",
        height: "60",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 34,
        name: "The Musical Band",
        image: "34.jpg",
        category: "Music",
        price: "126000",
        offerPrice: "0",
        width: "54",
        height: "48",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 35,
        name: "The Musical Band 5",
        image: "35.jpg",
        category: "Music",
        price: "210000",
        offerPrice: "0",
        width: "72",
        height: "60",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 36,
        name: "the butterfly whisper",
        image: "36.jpg",
        category: "Music",
        price: "700000",
        offerPrice: "0",
        width: "36",
        height: "36",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 37,
        name: "The Mesmerizing Tunes 11",
        image: "37.jpg",
        category: "Music",
        price: "75000",
        offerPrice: "0",
        width: "36",
        height: "42",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 38,
        name: "The Mesmerizing Tunes 19",
        image: "38.jpg",
        category: "Krishna",
        price: "84000",
        offerPrice: "0",
        width: "36",
        height: "48",
        inStock: "yes",
        description: "Acrylic on canvas",
      },
      {
        id: 39,
        name: "Rhythmic Exchange ",
        image: "39.jpg",
        category: "music",
        price: "137000",
        offerPrice: "0",
        width: "78",
        height: "36",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 40,
        name: "Musical band 10 ",
        image: "40.jpg",
        category: "music",
        price: "420000",
        offerPrice: "0",
        width: "120",
        height: "60",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 41,
        name: "Musical Theatre ",
        image: "41.jpg",
        category: "music",
        price: "140000",
        offerPrice: "0",
        width: "48",
        height: "60",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 42,
        name: "Where the Rhythm Takes You ",
        image: "42.jpg",
        category: "music",
        price: "140000",
        offerPrice: "0",
        width: "48",
        height: "60",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 43,
        name: "Melody of Purple",
        image: "43.jpg",
        category: "music",
        price: "84000",
        offerPrice: "0",
        width: "36",
        height: "48",
        inStock: "no",
        description: "Acrylic on canvas",
      },
      {
        id: 45,
        name: "Blossoming Bonds",
        image: "45.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "60",
        height: "36",
        inStock: "yes",
        description:
          "Blossoming Bonds portrays a serene scene of three figures in vibrant attire, gently interacting with swans amidst lush lotus flowers and green lily pads. A boat with a golden cloth adds warmth, symbolizing harmony and connection with nature. The bold colors and stylized forms evoke peace and unity.",
      },
      {
        id: 46,
        name: "Echoes of the Infinite",
        image: "46.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "72",
        height: "60",
        inStock: "yes",
        description:
          "Echoes of the Infinite depicts a divine ensemble of musicians, centered around a figure playing a Harp lute , surrounded by four others with drums and horns. Adorned in vibrant reds and golds, they sit against a backdrop of lotus motifs, evoking a timeless, spiritual harmony that resonates through eternity.",
      },
      {
        id: 46,
        name: "Echoes of the Infinite",
        image: "46.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "72",
        height: "60",
        inStock: "yes",
        description:
          "Echoes of the Infinite depicts a divine ensemble of musicians, centered around a figure playing a Harp lute , surrounded by four others with drums and horns. Adorned in vibrant reds and golds, they sit against a backdrop of lotus motifs, evoking a timeless, spiritual harmony that resonates through eternity.",
      },
      {
        id: 47,
        name: "Spiritual Raga",
        image: "47.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "72",
        height: "36",
        inStock: "yes",
        description:
          "Captures the essence of divine music, depicting three ascetics immersed in a sacred symphony. Their rhythmic tabla, soulful veena, and melodic lute create an aura of devotion. With earthy tones, intricate patterns, and expressive postures, the artwork evokes tranquility, spirituality, and the transcendental power of Indian classical music.",
      },
      {
        id: 48,
        name: "Celestial Conversations",
        image: "48.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "60",
        height: "36",
        inStock: "yes",
        description:
          "Celestial Conversations is a mesmerizing painting capturing the essence of ethereal love. Depicting a couple immersed in deep conversation, the canvas is adorned with the delicate presence of celestial butterflies. The interplay of cosmic hues and the soft glow of celestial beings create an enchanting atmosphere, inviting viewers into a realm of celestial romance.",
      },
      {
        id: 49,
        name: "Mystical Varanasi",
        image: "49.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "60",
        height: "36",
        inStock: "yes",
        description:
          "Mystical Varanasi captures the spiritual essence of India’s holiest city. The artwork blends divine symbolism with the vibrant architecture of Varanasi’s ghats, evoking a sense of meditation and transcendence. The deep blue hues, sacred markings, and serene expression invite viewers into a mystical journey of devotion and enlightenment.",
      },
      {
        id: 49,
        name: "Mystical Varanasi",
        image: "49.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "60",
        height: "36",
        inStock: "yes",
        description:
          "Mystical Varanasi captures the spiritual essence of India’s holiest city. The artwork blends divine symbolism with the vibrant architecture of Varanasi’s ghats, evoking a sense of meditation and transcendence. The deep blue hues, sacred markings, and serene expression invite viewers into a mystical journey of devotion and enlightenment.",
      },
      {
        id: 50,
        name: "Rhythm of Love",
        image: "50.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "48",
        height: "48",
        inStock: "yes",
        description:
          "This artwork beautifully portrays an intimate moment of harmony and connection between two figures, immersed in music and companionship. The vibrant colors, flowing drapery, and intricate patterns evoke a sense of timeless devotion. The flute, central to the composition, symbolizes the melody of love resonating through their bond.",
      },
      {
        id: 51,
        name: "The Eternal flute",
        image: "51.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "60",
        height: "36",
        inStock: "yes",
        description:
          "The Eternal Flute captures the divine harmony of Lord Krishna playing his flute, surrounded by two gopis enchanted by his music. The vivid red background contrasts with the serene green and gold tones, symbolizing devotion and love. A peacock, a timeless motif of beauty, completes this soulful, traditional composition.",
      },
      {
        id: 52,
        name: "Harmonious strings",
        image: "52.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "48",
        height: "60",
        inStock: "yes",
        description:
          '"Harmonious Strings" beautifully captures three musicians playing a diverse array of musical instruments. The painting emanates a sense of unity as the musicians blend their unique sounds into a melodious harmony. skillful use of colors and brushwork creates a visual symphony that resonates with the viewer\'s senses.',
      },
      {
        id: 53,
        name: "Reflections of Peace",
        image: "53.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "30",
        height: "36",
        inStock: "yes",
        description:
          '"Reflections of Peace" portrays a serene figure seated by a boat, surrounded by vibrant lotus flowers and lush greenery. The artwork blends rich greens, reds, and blues, evoking tranquility and harmony with nature. The contemplative pose and gentle colors reflect a deep sense of inner peace and connection to the environment.',
      },
      {
        id: 54,
        name: "Melody of the Lotus",
        image: "54.jpeg",
        category: "Music",
        price: "Price on request",
        offerPrice: "0",
        width: "28",
        height: "46",
        inStock: "yes",
        description:
          '"Melody of the Lotus" depicts a serene figure playing a flute, adorned with a garland of flowers and lotus buds. A graceful swan stands beside, while vibrant pink lotuses bloom above, symbolizing purity and harmony. The golden backdrop and intricate patterns evoke a divine, musical ambiance.',
      },
      {
        id: 55,
        name: "Glory of the bull",
        image: "55.jpeg",
        category: "Bull",
        price: "Price on request",
        offerPrice: "",
        width: "30",
        height: "24",
        inStock: "yes",
        description:
          '"Glory of the Bull" is a vibrant artwork blending bold colors and abstract forms. The bull, adorned with a red cap, exudes strength and mysticism against a striking red background. Intricate patterns and earthy tones create a cultural narrative, celebrating the bull\'s majestic presence with geometric and textured details.',
      },
    ];

    const myProductsArray = productArray.map((pItem, i) => {
      const isCategory =
        toLowercase(pItem.category) === toLowercase(this.props.category)
          ? true
          : false;
      return isCategory ? (
        <div className="image-grid">
          <ProductItem product={productArray[i]} key={i} />
        </div>
      ) : null;
    });
    return (
      <div className="pt-1">
        <div className="text-center">
          <h2>{this.props.category} Series</h2>
        </div>
        <div className="image-main-grid">{myProductsArray}</div>
      </div>
    );

    function toLowercase(text) {
      if (text !== undefined) {
        return text.toLowerCase();
      }
    }
    /* 
       const myProductsArray = productArray.map((pItem, i) => {
    const isCategory = pItem.category === this.props.category ? true : false;
    return isCategory ? (
      <li className="list-style" >
        <ProductItem product={productArray[i]} key={i} />
      </li>
    ) : null;
  });
  return (
    <div className="pt-1">
      <div><h2>{this.props.category} Series</h2></div>
      <ul className="list-group list-group-horizontal">
        {myProductsArray}
      </ul>
    </div>
  );
    */
  }
}

export default ProductList;
